export * from "./metadata.constants.js";
export * from "./account.constants.js";
export * from "./dataset.constants.js";
export * from "./flow.constants.js";
export * from "./app.constants.js";
export * from "./filepreview.constants.js";
export * from "./font.constants.js";
export * from "./format.constants.js";
export * from "./filepicker.constants.js";
export * from "./filter.constants.js";

export const MODULE_MAPPING = {
  platform: "kfplatform",
  case: "kfcase",
  page: "kfpage",
  application: "kfapplication",
  process: "kfprocess",
  components: "kfcomponents",
  analytics: "kfanalytics",
  appstore: "kfappstore"
};

export const ENV = {
  PRD: "Prd",
  UAT: "Uat"
};

export const DEVICE = {
  WEB: "Web",
  PWA: "Pwa"
};

export const DOCUMENT_VISIBILITY_STATES = {
  VISIBLE: "visible",
  HIDDEN: "hidden"
};

export const SERVICE_WORKER_LISTENER_TYPES = {
  PUSH_NOTIFICATION_CLICK: "PUSH_NOTIFICATION_CLICK",
  BASE_SIGNOUT: "BASE_SIGNOUT"
};

export const USER_EXTENSION_TYPES = {
  USER: "User"
};

export const WORK_PLATFORM_FEATURE_FLAGS = {
  ALLOW_WORK_PLATFORM_NAVIGATION: "allow_work_platform_navigation",
  FLOW_ALLOW_SECURITY_SETTING: "flow_allow_security_setting",
  APP_ALLOW_APP_MODULE: "app_allow_app_module",
  APP_ALLOW_APP_BUILDER: "app_allow_app_builder",
  APP_ALLOW_CODE: "app_allow_code",
  ADMIN_ALLOW_SANDBOX: "admin_allow_sandbox",
  ADMIN_ALLOW_SANDBOX_PROD: "admin_allow_sandbox_prod",
  ADMIN_ALLOW_SANDBOX_DEV: "admin_allow_sandbox_dev",
  ADMIN_ALLOW_SANDBOX_TEST: "admin_allow_sandbox_test",
  APP_ALLOW_APP_STORE: "app_allow_app_store",
  APP_STORE_ALLOW_FREE_APP: "app_store_allow_free_app",
  APP_STORE_ALLOW_PAID_APP: "app_store_allow_paid_app",
  APP_STORE_ALLOW_PROVISIONABLE_APP: "app_store_allow_provisionable_app",
  ALLOW_PROJECT_CREATION: "project_allow_project_creation",
  APP_ALLOW_APP_CODE: "app_allow_app_code",
  ADMIN_ALLOW_CUSTOM_PORTAL: "admin_allow_custom_portal",
  ADMIN_ALLOW_SERVICE_ACCOUNT_IMPERSONATION:
    "admin_allow_serviceaccount_impersonation",
  ADMIN_ALLOW_SERVICE_ACCOUNT: "admin_allow_admin_serviceaccount",
  ACCOUNT_ALLOW_ADMIN_GOVERNANCE: "account_allow_admin_governance",
  ADMIN_ALLOW_ACCOUNT_GOVERNANCE: "admin_allow_account_governance",
  KISSFLOW_ALLOW_LEFT_NAV: "kissflow_allow_left_nav",
  EXTERNALDATA_ALLOW_EXTERNALDATA_MODULE:
    "externaldata_allow_externaldata_module",
  DECISIONTABLE_ALLOW_DECISIONTABLE_MODULE:
    "decisiontable_allow_decisiontable_module",
  ALLOW_DOCUMENT_TEMPLATE_GENERATION_AI: "platform_allow_documenttemplate_ai",
  DATASET_ALLOW_AI_SAMPLE_DATA: "dataset_allow_ai_sampledata",
  INTEGRATION_ALLOW_ACCOUNT_CONNECTOR: "integration_allow_account_connector"
};

export const CHART_TYPES = {
  PIE: "pie",
  BAR: "bar",
  LINE: "line",
  AREA: "area",
  COMBO: "combo",
  SCATTER: "scatter",
  DOUGHNUT: "doughnut"
};

export const CHART_AXIS = {
  X_AXIS: "x",
  Y_AXIS: "y"
};

export const THEME = {
  LIGHT: "light",
  DARK: "dark",
  DIM: "dim"
};
export const SIGNATURE_PEN_COLOR = {
  DEFAULT: "#263045",
  LIGHT: "#263045" // subject to change in future
};
export const LEFTNAV_ACTION = {
  ACTIVATE: "Activate",
  ADD: "Add",
  UPDATE: "Update",
  DELETE: "delete"
};

export const ANALYTICS_FEATURE_FLAGS = {
  REPORT_VIEW_TABLE: "report_view_table",
  REPORT_VIEW_CHART: "report_view_chart",
  REPORT_VIEW_PIVOT: "report_view_pivot",
  REPORT_VIEW_DATAVIEW: "report_view_dataview",
  REPORT_CREATE_TABLE: "report_create_table",
  REPORT_CREATE_CHART: "report_create_chart",
  REPORT_CREATE_PIVOT: "report_create_pivot",
  REPORT_CREATE_DATAVIEW: "report_create_dataview"
};

export const CLOUD_PROVIDER = {
  GCP: "GCP",
  AWS: "AWS"
};

export const SDK_KIND = {
  LOWCODE: "lowcode",
  NOCODE: "nocode"
};

export const EXTERNAL_CONNECTOR_IMAGE_PATH = `${window.publicPath}media/images/external_connector_images`;

export const ALLOWED_FORM_FIELDS = {
  ALLOW_TEXT: "form_allow_text_field",
  ALLOW_TEXT_AREA: "form_allow_textarea_field",
  ALLOW_NUMBER: "form_allow_number_field",
  ALLOW_CURRENCY: "form_allow_currency_field",
  ALLOW_DATE: "form_allow_date_field",
  ALLOW_DATE_TIME: "form_allow_datetime_field",
  ALLOW_EMAIL: "form_allow_email_field",
  ALLOW_YESNO: "form_allow_yesno_field",
  ALLOW_ATTACHMENT: "form_allow_attachment_field",
  ALLOW_DROPDOWN: "form_allow_dropdown_field",
  ALLOW_CHECKBOX: "form_allow_checkbox_field",
  ALLOW_USER: "form_allow_user_field",
  ALLOW_IMAGE: "form_allow_image_field",
  ALLOW_LOOKUP: "form_allow_lookup_field",
  ALLOW_REMOTE_LOOKUP: "form_allow_remote_lookup",
  ALLOW_SLIDER: "form_allow_slider_field",
  ALLOW_STAR_RATING: "form_allow_starrating_field",
  ALLOW_AGGREGATION: "form_allow_aggregation_field",
  ALLOW_RICH_TEXT: "form_allow_richtext_field",
  ALLOW_SIGNATURE: "form_allow_signature_field",
  ALLOW_DEPENDENCY_DROPDOWN: "form_allow_dataset_dropdown",
  ALLOW_RADIO: "form_allow_radio_field",
  ALLOW_BUTTON: "form_allow_button_field",
  ALLOW_EVENT: "form_allow_event_code",
  ALLOW_SUGGESTED_FIELDS: "form_allow_suggested_fields",
  ALLOW_CHECKLIST: "form_allow_checklist_field",
  ALLOW_GEOLOCATION: "form_allow_geolocation_field",
  ALLOW_SCANNER: "form_allow_scanner_field",
  ALLOW_TRANSLATION: "form_allow_form_translation",
  ALLOW_AI_TRANSLATION: "form_allow_ai_translation"
};

export const ICON_BLOB_PATH = "common/resource/icons/";

export const KEY_PRIMARY_500 = "Color.Primary.500";

export const DEFAULT_COLOR_CODE = "#0565ff";

export const SAVE_INFO_STATUS = {
  DEFAULT: "default",
  PROGRESS: "progress",
  SUCCESS: "success",
  FAILED: "failed"
};

export const RTDB_STATUS = {
  COMPLETED: "Completed",
  FAILED: "Failed",
  IN_PROGRESS: "InProgress"
};
